/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PaymentResponsibility {
  ENROLLMENT_AGENT = 'ENROLLMENT_AGENT',
  EMPLOYEE = 'EMPLOYEE',
}
